import { render, staticRenderFns } from "./ControlButton.vue?vue&type=template&id=c0716b32&scoped=true&"
import script from "./ControlButton.vue?vue&type=script&lang=ts&"
export * from "./ControlButton.vue?vue&type=script&lang=ts&"
import style0 from "./ControlButton.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ControlButton.vue?vue&type=style&index=1&id=c0716b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0716b32",
  null
  
)

export default component.exports